export default __webpack_public_path__ + "static/media/DownloadArrowGold.21807b77.svg";